export default {
  methods: {
    getStarClassAtIndex(index, rating) {
      if (index * 2 <= rating) {
        return 'ga-star_filled';
      } else if ((index - 1) * 2 < rating) {
        return 'ga-star_half_filled';
      } else {
        return 'ga-star_sharp';
      }
    },
  },
};
